/**
 * Mini 3-point trend sparkline for KPI cards. SVG-only, no recharts overhead.
 * Renders the latest 3 values as a flat micro-line.
 */
export default function MiniTrend({ values = [], width = 56, height = 18, color = "currentColor" }) {
  if (!values || values.length < 2) {
    return <span className="text-[10px] text-slate-300 font-mono">—</span>;
  }
  const safe = values.map((v) => (typeof v === "number" && isFinite(v) ? v : 0));
  const min = Math.min(...safe);
  const max = Math.max(...safe);
  const range = max - min || 1;
  const step = width / (safe.length - 1);

  const points = safe.map((v, i) => {
    const x = i * step;
    const y = height - ((v - min) / range) * (height - 2) - 1;
    return [x, y];
  });

  const pathD = points
    .map((p, i) => `${i === 0 ? "M" : "L"} ${p[0].toFixed(1)} ${p[1].toFixed(1)}`)
    .join(" ");

  const lastTwo = safe.slice(-2);
  const trend = lastTwo[1] - lastTwo[0];
  const stroke = trend > 0 ? "#10B981" : trend < 0 ? "#EF4444" : "#94A3B8";

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="inline-block" style={{ color }}>
      <path d={pathD} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Last point dot */}
      <circle cx={points[points.length - 1][0]} cy={points[points.length - 1][1]} r="1.8" fill={stroke} />
    </svg>
  );
}
